import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

interface PageTopProps {
  text?: string;
  isMenu?: boolean; // true -> 메뉴버튼, false -> 홈버튼
  hasBackCloseButton?: boolean; // 왼쪽 뒤로가기, 닫기 버튼 유무
  hasButton?: boolean; // 오른쪽 버튼 모두 없는 경우
  hasSearch?: boolean; // 검색 버튼 유무
  logo?: boolean; // 로고 유무
  token?: string | null; // 실제 토큰 값
}

const PageTop = ({
  text,
  isMenu = true,
  hasBackCloseButton = true,
  hasButton = true,
  hasSearch = true,
  logo = false,
  token = null,
}: PageTopProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const tokenFromLocation =
    token ?? new URLSearchParams(location.search).get('token');

  return (
    <Container $bg={text === '전체메뉴' ? '#F3F4F6' : '#fff'}>
      {hasBackCloseButton && (
        <IconButton onClick={() => navigate(-1)}>
          <img src="/assets/images/arrow/arrow-left-black.svg" alt="back" />
        </IconButton>
      )}

      {logo && (
        <img
          src="/assets/images/logo/zipgoai_logo_mobile_header.svg"
          alt=""
          onClick={() => navigate('/')}
          style={{ padding: !hasBackCloseButton ? '2px 10px' : '' }}
        />
      )}

      <Title>{text}</Title>

      {hasButton && (
        <ButtonBox>
          {hasSearch && (
            <IconButton onClick={() => navigate('/quick-search')}>
              <img src="/assets/images/icon/search-black.svg" alt="search" />
            </IconButton>
          )}

          {isMenu ? (
            <IconButton
              onClick={() =>
                navigate(
                  tokenFromLocation
                    ? `/menu?token=${tokenFromLocation}`
                    : '/menu',
                )
              }
            >
              <img src="/assets/images/icon/menu-black.svg" alt="menu" />
            </IconButton>
          ) : (
            <IconButton onClick={() => navigate('/')}>
              <img src="/assets/images/icon/home-black.svg" alt="home" />
            </IconButton>
          )}
        </ButtonBox>
      )}
    </Container>
  );
};

export default PageTop;

const Container = styled.div<{ $bg?: string }>`
  display: flex;
  width: 100%;
  padding: 6px;
  align-items: center;
  gap: 2px;
  position: sticky;
  top: 0;
  background-color: ${({ $bg }) => ($bg ? $bg : '#fff')};
  z-index: 1000;
`;

const IconButton = styled.div`
  display: flex;
  padding: 10px;
  align-items: center;

  & > img {
    width: 24px;
    height: 24px;
  }
`;

const Title = styled.div`
  display: flex;
  height: 44px;
  align-items: center;
  flex: 1 0 0;

  color: #222;
  font-size: 16px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.32px;
`;

const ButtonBox = styled.div`
  display: flex;
  align-items: center;
`;
